import { Link } from "react-router-dom";
export default function AppHeader() {
  return (
    <nav
      className="navbar bg-primary navbar-expand-lg bg-body-tertiary"
      data-bs-theme="dark"
    >
      <div className="container-fluid">
        <a className="navbar-brand" href="/">
          Anupam Pal
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <a className="nav-link active" aria-current="page" href="/">
                HOME
              </a>
            </li>
            <li className="nav-item">
              <Link className="nav-link active" to="music-series">
                MUSIC SERIES
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link active" to="bull-series">
                BULL SERIES
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link active" to="genesha-series">
                GENESHA SERIES
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link active" to="krishna-series">
                KRISHNA SERIES
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link active" to="durga-series">
                DURGA SERIES
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link active" to="hourse-series">
                HOURSE SERIES
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link active" to="about-us">
                ABOUT US
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link active" to="contact-us">
                CONTACT US
              </Link>
            </li>
            {/* <li className="nav-item">
              <a className="nav-link active" aria-current="page" href="/">
                BLOG
              </a>
            </li> */}
          </ul>
        </div>
      </div>
    </nav>
  );
}
